<template>
  <component :is="tag" @click.stop="rebet" :class="{ 'bto-sb-loader': isLoading }">
    <i class="bto-sb-spinner-v1" v-if="isLoading"></i>
    {{ t("M.Rebet") }}
  </component>
</template>
<script>
  import store from '@/store';
  import { EventBus } from '@/services/event-bus-service';
  import { mapForBetSlip, mapBoostedForBetslip } from '@/services/rebet';
  import { betslipStore, clearBetslip, toggleItem, toggleAlgoItem, changeTab, toggleBanker, getTabs, resetQuickbet } from '@bto-services/betslip-core';
  import { BETSLIP_STATUS, mapMatchToBetslipItem, mapMatchToBetslipMatchItem, mapBoostedBetToBetslip, ITEM_TYPES, getLayout, BETSLIP_LAYOUTS, BETSLIP_TYPES, remapBetBuilderRebet } from 'bto-models/betslip';
  import BetBuilderMybetDetailsService from '@bto-services/api/shared/betbuilder-mybet-details.request';
  import BoostedOddsMybetDetailsService from '@bto-services/api/shared/boosted-odds-mybet-details.request';
  import AlgoMybetDetailsService from '@bto-services/api/shared/algo-mybet-details.request';
  import MatchesOddsModel from '@/models/model-match-odds';
  // import MatchesOutcomeModel from '@/models/model-match-outcome';
  import { DateFilterService } from '@bto-services/utils';
  import { checkEnrichedName } from 'bto-models/utils/string';

  const { PLACED } = BETSLIP_STATUS;
  export default {
    name: 'RebetButton',
    props: {
      betDetails: {
        type: Object,
        required: true,
      },
      tag: {
        type: String,
        default: 'button',
      }
    },
    data() {
      return {
        bbDetails: null,
        boostedEventIds: null,
        algoBBDetails: null,
        isLoading: false,
      };
    },
    computed: {
      isMobile() {
        return store.state.GlobalModule.isMobile;
      },
    },
    created() {
      EventBus.$on(`confirmOverwrite_${this.betDetails.betSlipGroupID}`, this.overWrite);
      EventBus.$on(`backCancel_${this.betDetails.betSlipGroupID}`, this.hideModal);
    },
    destroyed() {
      EventBus.$off(`confirmOverwrite_${this.betDetails.betSlipGroupID}`, this.overWrite);
      EventBus.$on(`backCancel_${this.betDetails.betSlipGroupID}`, this.hideModal);
    },
    methods: {
      rebet() {
        resetQuickbet();
        const hasItems = Object.keys(betslipStore.items).length > 0;
        if (hasItems) {
          this.showModal();
          return;
        }
        this.processRebet();
      },
      showModal() {
        EventBus.$emit('modalMessage', {
          showModal: true,
          title: this.$translate.text('M.RebetConfirm'),
          messageType: 'info',
          messageText: this.$translate.text('M.RebetDescription'),
          modalSize: 'md',
          buttons: [
            {
              label: this.$translate.text('M.Overwrite'),
              event: `confirmOverwrite_${this.betDetails.betSlipGroupID}`,
            },
            {
              label: this.$translate.text('Public.Close'),
              event: `backCancel_${this.betDetails.betSlipGroupID}`,
            }
          ],
        });
      },
      overWrite() {
        clearBetslip();
        this.processRebet();
        this.hideModal();
      },
      async processRebet() {
        if (this.isLoading) {
          return;
        }
        // Checks if some of the items are of a type "bet builder" and with status "placed",
        // if there are, we get the details for all of them at once, instead making call with each iteration
        if (this.betDetails.items.some(x => x.itemTypeId === ITEM_TYPES.BET_BUILDER && x.itemStatusId === PLACED) && !this.bbDetails) {
          const betBuilderDetails = new BetBuilderMybetDetailsService(this.betDetails.betSlipGroupID);
          this.isLoading = true;
          await betBuilderDetails.execute().then(resp => {
            if (!resp.data || !resp.data.i) {
              return;
            }
            this.bbDetails = resp.data.i.reduce((acc, i) => {
              acc[i.mid] = i;
              return acc;
            }, {})
          }).finally(() => { this.isLoading = false; });
        }
        if (this.betDetails.items.some(x => x.itemTypeId === ITEM_TYPES.BOOSTED_ODD && x.itemStatusId === PLACED) && !this.boostedEventIds) {
          const boostedOddsDetails = new BoostedOddsMybetDetailsService(this.betDetails.betSlipGroupID);
          this.isLoading = true;
          await boostedOddsDetails.execute().then(resp => {
            if (!resp.data) {
              return;
            }
            this.boostedEventIds = resp.data;
          }).finally(() => { this.isLoading = false; });
        }
        if(this.betDetails.items.some(x => x.itemTypeId === ITEM_TYPES.ALGO && x.itemStatusId === PLACED) && !this.algoBBDetails) {
          const algoDetails = new AlgoMybetDetailsService(this.betDetails.betSlipGroupID);
          this.isLoading = true;
          await algoDetails.execute().then(resp => {
            if (!resp.data) {
              return;
            }
            this.algoBBDetails = resp.data.reduce((acc, i) => {
              acc[i.mid] = i;
              return acc;
            }, {})
          }).finally(() => { this.isLoading = false; });
        }
        this.betDetails.items.forEach((ev) => {
          if (ev.itemStatusId === PLACED) {
            let betslip_item = {};
            if(ev.itemTypeId === ITEM_TYPES.BOOSTED_ODD) {
              const indexOfIds = this.boostedEventIds.findIndex((el) => ev.matchID === +el.mid);
              const mappedEventIds = this.boostedEventIds[indexOfIds].mids.split(',').map((id) => parseInt(id, 10));
              betslip_item = mapBoostedForBetslip(ev, mappedEventIds);
              const { item, match } = mapBoostedBetToBetslip(betslip_item, this.$translate.text('BO.BoostedOdd'));
              toggleItem(item, match);
            } else if (ev.itemTypeId === ITEM_TYPES.ALGO) {
              const algoOdds = this.algoBBDetails[ev.matchID].o;
              algoOdds.forEach((o) => {
                let aOdd = new MatchesOddsModel(o, ev.homeTeam, ev.guestTeam);
                if (o.m !== null) {
                  // aOdd.outcomes = o.m.map((m) => new MatchesOutcomeModel(m, ev.homeTeam, ev.guestTeam));
                  aOdd.outcomes = o.m.map((m) => {
                    return {
                      active: typeof m.a !== 'undefined' ? m.a : false,
                      id: m.id,
                      name: m.n,
                      enrichedOutcomeName: checkEnrichedName(m.eon, ev.homeTeam, ev.guestTeam, m.sbv),
                      outcome: m.o,
                      originalDecimalOutcome: m.o,
                      identifier: m.i,
                      specifier: m.sp,
                      sbv: m.sbv,
                      suspended: m.su,
                      competitorId: m.cmid
                    }
                  });
                }
                const itemType = this.algoBBDetails[ev.matchID].it;
                const algoItemEv = {
                  homeTeam: ev.homeTeam,
                  guestTeam: ev.guestTeam,
                  sportId: ev.sportId,
                  sportName: ev.sportName,
                  categoryId: ev.categoryId,
                  categoryName: ev.categoryName,
                  tournamentId: ev.tournamentId,
                  tournamentName: ev.tournamentName,
                  matchId: ev.matchID,
                  betRadarId: ev.betRadarId,
                  eventCode: ev.eventCode,
                  utcDate: ev.eventDateString,
                  cashoutAvailable: ev.cashoutAvailable,
                  date: DateFilterService.localDate(ev.eventDateString, 'date', APP_SETTINGS.formatting.shortDateFormat, ''),
                  time: DateFilterService.localDate(ev.eventDateString, 'time', '', APP_SETTINGS.formatting.shortTimeFormat),
                  odds: aOdd,
                  suspended: this.algoBBDetails[ev.matchID].su,
                  awayAtHome: ev.isUS,
                  name: ev.isUS ? `${ev.guestTeam} @ ${ev.homeTeam}` : `${ev.homeTeam} vs ${ev.guestTeam}`,
                }
                betslip_item = mapMatchToBetslipItem(
                  algoItemEv,
                  aOdd.outcomes[0],
                  aOdd,
                  itemType === ITEM_TYPES.OUTRIGHT,
                  itemType === ITEM_TYPES.PRE_MATCH,
                  false,
                  itemType === ITEM_TYPES.LIVE);
                const betslipMatchItem = mapMatchToBetslipMatchItem(algoItemEv, itemType === ITEM_TYPES.OUTRIGHT);
                toggleAlgoItem(betslip_item, betslipMatchItem);
              });
            } else {
              const { match, outcome, odd, itemType } = mapForBetSlip(ev);  
              betslip_item = mapMatchToBetslipItem(
                match,
                outcome,
                odd,
                itemType === ITEM_TYPES.OUTRIGHT,
                itemType === ITEM_TYPES.PRE_MATCH,
                false,
                itemType === ITEM_TYPES.LIVE);
              const betslipMatchItem = mapMatchToBetslipMatchItem(match, itemType === ITEM_TYPES.OUTRIGHT);
              remapBetBuilderRebet(betslip_item, betslipMatchItem, itemType, this.bbDetails);
              toggleItem(betslip_item, betslipMatchItem);
            }         

            if (ev.banker) {
              toggleBanker(betslip_item);
            }
          }
        });
        if (this.isMobile) {
          this.$router.push({ name: 'betslip' });
        }
        const groupTypeId = this.betDetails.betSlipGroupTypeId;

        if (getLayout() === BETSLIP_LAYOUTS.TABS && groupTypeId) {
          const tabs = getTabs();
          /**
           * Check if group type is one of the betslip tabs
           * If it's freebet or jackpot it won't be one of the betslip tabs
           * so we need to set it to COMBI tab if available
           * or if not default it to the first set tab
           */
          switch (true) {
            case tabs.some(t => t.id === groupTypeId):
              changeTab(groupTypeId);
              break;
            case tabs.some(t => t.id === BETSLIP_TYPES.COMBI):
              changeTab(BETSLIP_TYPES.COMBI);
              break;
            default:
              changeTab(tabs[0].id);
              break;
          }
        }
        // If floating betslip expand it
        if (APP_SETTINGS.betslip_v2.floatingBetslip) {
          document.body.classList.add('bto-sb-betslip-fixed-open');
        }
      },
      hideModal() {
        EventBus.$emit('modalMessage', {
          showModal: false,
        });
      },
    },
  };
</script>
